import { isSafeEmailValue } from './is-safe-email-value.js';
// WHY: this value is rendered as a live mailto: href, so an unsafe stored value (e.g. a
// pre-existing row with a header-injection payload) must be rejected here, not just at write time.
export function emailHref(email) {
    const trimmed = email?.trim();
    if (!trimmed)
        return null;
    return isSafeEmailValue(trimmed) ? `mailto:${trimmed}` : null;
}
//# sourceMappingURL=email-href.js.map